"use strict";

exports.__esModule = true;
exports.timeRenderer = exports.RENDERER_TYPE = void 0;
var _timeRenderer = require("./timeRenderer");
exports.RENDERER_TYPE = _timeRenderer.RENDERER_TYPE;
exports.timeRenderer = _timeRenderer.timeRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/timeRenderer/index.js
// module id = 577
// module chunks = 0